import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import send from '../assets/img/svg/send.svg'
import map from '../assets/img/svg/map-1.svg'
import moon from '../assets/img/svg/moon.svg'
import verified from '../assets/img/svg/verified.svg'
import user from '../assets/img/svg/user-1.svg'

import TinySlider from "tiny-slider-react";
import '../../node_modules/tiny-slider/dist/tiny-slider.css'
import { deleteSpace } from '../services/ApiServices';
import toast from 'react-hot-toast';

const settings = {
  items: 1,
  controls: false,
  mouseDrag: true,
  loop: true,
  rewind: true,
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: "bottom",
  nav: true,
  speed: 400,
  gutter: 0,
};

export interface gridPropertyProp {
  item: any;
  isEditable: boolean;
  border: any;
  mySpaceAPICall?: any;
}

export default function GridProperty({ item, border, isEditable, mySpaceAPICall }: gridPropertyProp) {
  const navigate = useNavigate();
  const [isShowDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  var price: any;
  var sfPrice: any;

  const formatNumber = (value: string) => {
    return parseFloat(value).toString();
  };

  const amountFormatter = (amount: any) => {
    const formattedAmount = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
    console.log("formattedAmount", formattedAmount);

    return formattedAmount;
  };

  if (item?.price) {
    if (item?.square_feet > 0) {
      price = `${amountFormatter(item.square_feet)} SF`
    }
  } else {
    if (item?.square_feet) {
      price = `${amountFormatter(item.square_feet)} SF`
    }
    if (item?.price_per_square) {
      sfPrice = `${amountFormatter(item.price_per_square)} PSF`
    } else {
      sfPrice = `$${amountFormatter(item.monthly_rent)} Mth`
    }
  }
  const handleDeleteSpace = () => {
    const data = new FormData();
    data.append("space_id", item.id)
    deleteSpace(data).then((res) => {
      console.log("delete space deleted", res);
      if (res?.status === "success") {
        toast.success(res.message);
        setShowDeleteModal(false)
        mySpaceAPICall()
      }
    }).catch((err) => {
      console.log("error deleting space", err);

    })
  }
  return (
    <div className={`property-listing card rounded-3 ${border ? 'border' : 'border-0'}`}>
      <div className={`listing-img-wrapper p-3 `}>
        <div className="list-img-slide position-relative">
          <div className="position-absolute top-0 left-0 ms-3 mt-3 z-1">
            {/* {item.tag.map((el: any, index: number) => {
              return (

                <div key={index} className={`label text-light d-inline-flex align-items-center justify-content-center mx-1 ${el === 'Verified' ? 'bg-success' : ''} ${el === 'SuperAgent' ? 'bg-purple' : ''} ${el === 'New' ? 'bg-danger' : ''}`}>
                  {el === 'Verified' && <img src={verified} alt="" className='me-1' />}

                  {el === 'SuperAgent' && <img src={user} alt="" className='me-1' />}

                  {el === 'New' && <img src={moon} alt="" className='me-1' />}
                  {el}
                </div>
              )
            })} */}
          </div>
          <div className="click rounded-3 overflow-hidden mb-0">
            <div><Link to={`#`}><img src={item?.image} className="img-fluid" alt="" /></Link></div>
            {/* <TinySlider settings={settings}>
              {item.image.map((el: any, index: number) => {
                return (
                  <div key={index}><Link to={`#`}><img src={el} className="img-fluid" alt="" /></Link></div>
                )
              })}
            </TinySlider> */}
          </div>
        </div>
      </div>

      <div className="listing-caption-wrapper px-3">
        <div className="listing-detail-wrapper">
          <div className="listing-short-detail-wrap">
            <div className="listing-short-detail">
              <div className="d-flex align-items-center">
                <span className="label bg-light-success text-success prt-type me-2">{item.monthly_rent ? "For Lease" : "For Sale"}</span>
              </div>
              <h4 className="listing-name fw-semibold fs-5  mt-3">{item.address}</h4>
              {/* <div className="prt-location text-muted-2 d-flex">
                <img src={map} alt="" />
                {item?.address}
              </div> */}
            </div>
          </div>
        </div>

        <div className="price-features-wrapper mb-2">
          <div className="list-fx-features d-flex align-items-center justify-content-between">
            <div className="listing-card d-flex align-items-center">
              <div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-building-shield fs-xs"></i></div><span className="text-muted-2 fs-sm">{item.property_type}</span>
            </div>
            <div className="listing-card d-flex align-items-center">
              <div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-bed fs-xs"></i></div><span className="text-muted-2 fs-sm">{price}</span>
            </div>
            <div className="listing-card d-flex align-items-center">
              {sfPrice && <><div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-clone fs-sm"></i></div><span className="text-muted-2">{sfPrice}</span></>}
              {/* {!sfPrice && <AmountFormatter amount={item.price} />} */}
              {!sfPrice && <><div className="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i className="fa-solid fa-clone fs-xs"></i></div><span className="text-muted-2 fs-sm">{`$${amountFormatter(item.price)}`}</span></>}
            </div>
          </div>
        </div>

        <div className="listing-detail-footer d-flex align-items-center justify-content-between mb-2">
          {isEditable ? <div className="footer-flex">
            <button className="btn btn-md btn-primary fw-medium me-2" onClick={() => navigate("/add-space", { state: item })}>Edit Property</button>
            <button className="btn btn-md btn-danger fw-medium" onClick={() => setShowDeleteModal(true)}>Delete Property</button>
          </div> :
            <div className="footer-flex">
              <button className="btn btn-md btn-primary fw-medium me-2" onClick={() => navigate(`/property-details/${item?.id}`)}>View Property</button>
            </div>
          }
        </div>

      </div>
      {
        isShowDeleteModal &&
        <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
          <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
            <div className="modal-content" id="registermodal">
              <span className="mod-close" onClick={() => setShowDeleteModal(!isShowDeleteModal)}>
                <span className="svg-icon text-primary svg-icon-2hx">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                    <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                    <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                  </svg>
                </span>
              </span>
              <div className="modal-body">

                <div className="modal-body">
                  <h4 className="modal-header-title" style={{ fontSize: 25 }}>Delete Space</h4>
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <span>Are you sure you want to delete sapce?</span>
                  </div>
                  <div className="form-group d-flex">
                    <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setShowDeleteModal(!isShowDeleteModal)}>Cancel</button>
                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => handleDeleteSpace()}>Delete Space</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}
